import { render, staticRenderFns } from "./CmsPageItem.vue?vue&type=template&id=db4aa0c0&scoped=true&"
import script from "./CmsPageItem.vue?vue&type=script&lang=js&"
export * from "./CmsPageItem.vue?vue&type=script&lang=js&"
import style0 from "./CmsPageItem.vue?vue&type=style&index=0&id=db4aa0c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4aa0c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardActions,VListItem,VListItemContent,VListItemTitle})
